export default __webpack_public_path__ + "static/media/datastream.a0899c1d.png";